<template>
    <div class="specs-choose">
        <div class="choose-type">
            <el-select v-model="ruleType" @change="typeChange" :disabled="disabled">
                <el-option v-for="rule in ruleList" :key="rule.id"
                :value="rule.id" :label="rule.name"
                ></el-option>
            </el-select>
            <!-- <el-input></el-input>
            <el-button>添加</el-button> -->
            <el-button @click="delRow" v-if="dataLength==0">删除</el-button>
        </div>
        <div class="item-box">
            <div class="specs-item" :class="{'active':specs.active,'disabled':specs.disabled}" @click="specsClick(specs)" v-for="(specs,index) in specsList" :key="index">
                {{specs.name}}</div>
        </div>
    </div>
</template>
<script>
  import api from '@/config/api';
export default {
    props:['comId','dataLength','specsRow'],
    data(){
        return {
            plain:false,
            disabled:false,
            ruleType:'',
            ruleList:[],
            specsList:[],
            avtiveRule:{}
        }
    },
    created(){
        this.getRuleList();
    },
    methods:{
        specsClick(specs){
          if(!specs.disabled){
            specs.active = !specs.active;
            this.$emit('specsChange',this.avtiveRule,this.specsList,this.comId,specs);
          }
        },
        typeChange(){
            this.disabled = true;
            this.avtiveRule = this.ruleList.filter(item => item.id == this.ruleType)[0];
            this.$emit('ruleChange',this.avtiveRule,this.comId);
        },
        typeChangeFail(){
            this.disabled = false;
            this.ruleType = '';
            this.avtiveRule = null;
        },
        typeChangeSuccess(){
            this.specsList = this.avtiveRule.children;
        },
        getRuleList(){
            this.$axios.fetchPost(api.archives.goodsSpecs + '/list',{})
            .then(data => {
                this.loading = false;
                if (data.code == 200 && data.data) {
                    this.ruleList = this.$utils.dealCascadeData(data.data);
                    this.$emit('ruleListGetSuccess',this.comId);
                } else {
                    this.$message({ message: "请求失败！", type: "error" });
                }
            }).catch(err => {
                console.log(err);
                this.$message({ message: "请求失败！", type: "error" });
                this.loading = false;
            });
        },
        delRow(){
            this.$emit('ruleDelete',this.comId);
        }
    }
}
</script>
<style>
    .specs-choose{
        /*margin-bottom: 10px;*/
    }
    .specs-choose .choose-type{
      line-height: 30px;
      padding-top: 10px;
    }
    .specs-choose .item-box{
        display: flex;
        flex-direction: row;
    }
    .specs-choose .item-box .specs-item.active{
        border-color: rgb(64,158,255);
        color: rgb(64,158,255);
    }
    .specs-choose .item-box .specs-item.disabled{
      border-color: rgba(64,158,255,.6);
      color: rgba(64,158,255,.6);
      background-color: rgba(236,245,255,.6);
      cursor: not-allowed;
    }
    .specs-choose .item-box .specs-item{
        width: 120px;
        height: 30px;
        line-height: 30px;
        margin-right: 10px;
        margin-top: 10px;
        background-color: #fff;
        padding:0 10px;
        border:1px solid #ccc;
        border-radius: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/business/specsChoose.vue